<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un encaissement groupé"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <div class="d-sm-flex align-items-center">
        <!-- <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            href="#"
          >
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            Ajouter un reglement
        </a> -->

          <router-link to="/Ajout-reglement-groupe" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            <span class="title">Ajouter un reglement groupe</span>
          </router-link>
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Reference
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  Date
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Agent
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Montant
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(reg, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ reg.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ reg.reference }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ format_date(reg.dateReglement) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ reg.utilisateur.nom+" "+ reg.utilisateur.prenoms }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ reg.montantTotal }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                    <div class="dropdown">
                        <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Actions
                            <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                        </span>
                        <ul class="dropdown-menu">
                            <li>
                            <a
                                class="dropdown-item d-flex align-items-center"
                                href="javascript:void(0);"
                                data-bs-toggle="modal"
                                data-bs-target="#AddElementModal"
                                @click="detail(reg.id, reg.montantTotal)"
                            >
                                <i class="flaticon-pen lh-1 me-8 position-relative top-1"
                                ></i>
                                Detail
                            </a>
                            </li>
                            <!-- <li>
                            <a
                                class="dropdown-item d-flex align-items-center"
                                href="javascript:void(0);" @click="suppression(reg.id,elements,'reglement','ce reglement')"
                            >
                                <i
                                class="flaticon-delete lh-1 me-8 position-relative top-1" 
                                ></i>
                                Supprimer
                            </a>
                            </li> -->
                        </ul>
                    </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <div class="modal fade createNewModal" id="AddElementModal" tabindex="-1"  aria-hidden="true" >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">Détails</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col"  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  >
                  Date
                </th>
                <th scope="col" 
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  client
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Montant
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Reste A payer
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(re, index) in reglements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ re.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ format_date(re.dateReglement) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{  " [ "+ re.vente.client.code +" ] "+ re.vente.client.nom+" "+re.vente.client.prenoms }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ re.montant }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ re.restAPayer }}
                </td>
              </tr>
              <tr>
                <td colspan="3" class="shadow-none lh-1 fw-medium text-paragraph">
                  Total
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ total }}
                </td>
                <td>
                  -
                </td>
              </tr>
            </tbody>
          </table>
        </div>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>

  </template>
  
  <script lang="ts">

    import { defineComponent, ref, onMounted } from 'vue';
    import { paginationFields } from '../Utilities/paginationFields';
    import { error, suppression, format_date } from '../../utils/utils';
    import ApiService from "../../services/ApiService";
    import  { GroupementReglement }  from '../../models/GroupementReglement';
    import  { Reglement }  from '../../models/Reglement';
    import PaginationComponent from '@/components/Utilities/Pagination.vue';

  export default defineComponent({
    name: "ListeReglementGroupe",
    components : {
      PaginationComponent
    },
    setup: () => {

      const elements = ref<Array<GroupementReglement>>([]);
      const reglements = ref<Array<Reglement>>([]);
      const selectedItem = ref(0);
      const element = ref<GroupementReglement>();
      const total = ref(0);
     
      function modification(item) {
        element.value = item;
        selectedItem.value = item.id;
      }

      // BEGIN PAGINATE
      const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_);
          } catch (error) {
            //
            
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE

      const recharger = () => {
        getAll();
      };

      onMounted(() => {
        getAll();
      })

      function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`reglementsGroupe?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('result', data.data.data.montantTotal);
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      } 

      function detail(rg, mt) {
        return ApiService.get(`reglements?reglementGroupe=${rg}&`)
        .then(({ data }) => {
          console.log('reglements', data.data.data);
          total.value = mt;
          reglements.value = data.data.data;
        })
        .catch(({ response }) => {
          error(response.data)
        });
      }
      

      return { 
        getAll,
        elements,
        recharger,
        selectedItem,
        format_date,
        detail,
        reglements,
        suppression,
        total,

        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher
      };

    }

  });
  </script>